export default __webpack_public_path__ + "static/media/goshen30.6a356ead.jpg";